import _ from 'lodash';

import { getPathVariables } from '../../misc';

const getFormattedPricing = pricing => {
  const locale = getPathVariables(window.location.pathname)[0];
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD'
  });

  return formatter.format(pricing).replace('US', '');
};

// Compute, for each row in `list`, whether it should render the leading
// Service cell and how many rows that cell should rowSpan across. When
// `enabled` is false the helper returns no-op metadata so the table renders
// exactly as it did before the Service-column feature.
export const buildServiceMeta = (list, enabled) => {
  const meta = list.map(() => ({ shouldRender: false, rowSpan: 1 }));
  if (!enabled) return meta;

  let groupStart = -1;
  let groupType = null;
  list.forEach((addon, index) => {
    if (_.get(addon, 'fields.isHeader', false)) {
      groupStart = -1;
      groupType = null;
      return;
    }
    const sectionType = _.get(addon, 'fields.productSectionType', '');
    if (!sectionType) {
      meta[index] = { shouldRender: true, rowSpan: 1 };
      groupStart = -1;
      groupType = null;
      return;
    }
    if (sectionType === groupType && groupStart !== -1) {
      meta[groupStart].rowSpan += 1;
    } else {
      meta[index] = { shouldRender: true, rowSpan: 1 };
      groupStart = index;
      groupType = sectionType;
    }
  });
  return meta;
};

export default getFormattedPricing;
